<div style="text-align: right;">
  <i class="fa fa-window-close" style="font-size:14px; cursor: pointer"
  (click)="close.click()">
  <button #close style="display:none;" (click)="onNoClick()">
  <!-- <button type="button" #close  style="display:none;" (click)="openFileUploadDialog()"></button> -->
  </button>
  </i> 
  </div>
   <div class="main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <form [formGroup]="addmore" (ngSubmit)="GetResult()">
            <div class="card-body">
             
                <div class="card-header card-header-danger">
                  <div class="row">
                    <div class="col-md-12">
                      <button type="submit"  class="btn-primary1" >Run</button>
                      &nbsp;
                      <button type="button"  class="btn-primary1"  (click)="SaveFilterDetail()">Save</button>
                      <!-- &nbsp;
                      <button type="button"  class="btn-primary1"  (click)="ResetAndGetResult()">Reset & GetResult</button> -->

                    </div>
                    </div>
                  </div>
                  
                 
                </div>
                <div class="card-body">
                    
                  <div class="col-sm-12" formArrayName="FilterList">
                  <div class="row">
                    <div class="col-md-12">
                      All of these conditions must be met
                      </div>
                      </div>
                      <div class="row" *ngFor="let itemrow of addmore.controls.FilterList['controls']; let i=index" [formGroupName]="i">
                        <div class="col-md-3">
                          <p-dropdown [options]="MultiFilterArrayList[i]" placeholder="--Choose Field--"  (onChange)="ChangeDataTypeINList($event,i)"
                          formControlName="FilterColumnsID"  >
                        </p-dropdown>
                        <mat-error
                        *ngIf="GetFormControls('FilterColumnsID' , i).invalid && (GetFormControls('FilterColumnsID' , i).dirty || GetFormControls('FilterColumnsID' ,i).touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('FilterColumnsID' , i).errors.required">
                         Choose Field is Required
                        </mat-error>
                      </mat-error>
                          <!-- <mat-select  id="FilterColumnsID{{i}}"  formControlName="FilterColumnsID" class="form-control" (selectionChange)="ChangeDataTypeINList($event,i)">
                            <mat-option *ngFor="let item of  this.MultiFilterArrayList[i]" [value]="item.FilterColumnID">
                              {{item.FilterColumnsDisplay}}
                            </mat-option>
                          </mat-select> -->
                        </div>
                        <div class="col-md-3">
                         
                            <p-dropdown [options]="resultArray[i]" placeholder="--Choose--" 
                            (onChange)="ChangeFilterContainValue($event,i)"  formControlName="FilterContainValues"
                            >
                          </p-dropdown>
                          <mat-error
                          *ngIf="GetFormControls('FilterContainValues', i).invalid && (GetFormControls('FilterContainValues' , i).dirty || GetFormControls('FilterContainValues' , i).touched)"
                          class="ValidationError">
                          <mat-error *ngIf="GetFormControls('FilterContainValues', i).errors.required">
                           Choose Field is Required
                          </mat-error> 
                        </mat-error>
                          
                        </div>
                        <div class="col-md-3">
                          <input  formControlName="SearchText"  class="form-control">
                          <mat-error
                        *ngIf="GetFormControls('SearchText', i).invalid && (GetFormControls('SearchText', i).dirty || GetFormControls('SearchText', i).touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('SearchText', i).errors.required">
                         Choose Field is Required
                        </mat-error> 
                      </mat-error>
                        </div>
                        <div class="col-md-3">
                          <i class="fa fa-plus" style="font-size:14px; cursor: pointer"
                          (click)="Add.click()">
                          <button type="button" #Add  style="display:none;" (click)="addNewRow(i)"></button>
               
              </i>&nbsp;
                          <button *ngIf="addmore.controls.FilterList.controls.length > 1" (click)="deleteRow(i)" ><i class="far fa-trash-alt" aria-hidden="true"></i></button>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                        
                        </div>
                      </div>
                      </div>
                      </div>
              </form>
            
            </div>
  
          </div>
        </div>
  
      </div>
    </div>
  
<!-- <div class="container-fluid">
  <form [formGroup]="addmore" (ngSubmit)="GetResult()">
 
  <div class="card-body">

       
      <div class="row">
      <div class="col-sm-12 table-responsive" formArrayName="FilterList">
      <table class="table">
      <thead>
      <tr>
      <th style="white-space: nowrap;padding-right: 4em;float:center" colspan="4">All of these conditions must be met</th>
    
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let itemrow of addmore.controls.FilterList['controls']; let i=index" [formGroupName]="i">
       
      <td style="white-space: nowrap;"> 
       
        <mat-select  id="FilterColumnsID{{i}}"  formControlName="FilterColumnsID" class="form-control" (selectionChange)="ChangeDataTypeINList($event,i)">
          <mat-option *ngFor="let item of MultiFilterList" [value]="item.FilterColumnID">
            {{item.FilterColumnsDisplay}}
          </mat-option>
        </mat-select>
      
     </td>
      <td> 
      
        <mat-select  id="FilterContainValues{{i}}"  (selectionChange)="ChangeFilterContainValue($event,i)"  formControlName="FilterContainValues" class="form-control" >
        
          <mat-option *ngFor="let item of resultArray[i]" [value]="item.FilterContainId">
            {{item.FilterContainDisplayText}}
          </mat-option>
        </mat-select>
     </td>
      <td> 
    
        <input  formControlName="SearchText"  class="form-control">
      </td>
  
      <td> <button *ngIf="addmore.controls.FilterList.controls.length > 1" (click)="deleteRow(i)" class="btn btn-danger"><i class="fa fa-minus-circle" aria-hidden="true"></i></button></td>
      </tr>
      </tbody>
      <tfoot>
      <tr><td> <button type="button" (click)="addNewRow()" class="btn btn-primary"><i class="fa fa-plus-circle" aria-hidden="true"></i></button></td></tr>
      </tfoot>
      </table>
      </div>
       
      </div>
       
       
      </div>
      
      <div class="card-footer">
      <button type="submit" mat-raised-button color="primary" >Get Result</button>
      </div>
    
      </form>
       
      </div> -->